<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.countingOrderNo')" allowClear @pressEnter="getData" @search="getData" />
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-select v-model="query['countingType']" :placeholder="$t('placeholder.countingType')" allowClear class="query">
        <a-select-option v-for="d in countingTypeData" :key="d.ordinal">{{ d.name }}</a-select-option>
      </a-select>
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="getData" @search="getData" />
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear @pressEnter="getData" @search="getData" />
      <a-input-search v-model="query['item.barcodes']" :placeholder="$t('placeholder.itemBarcode')" allowClear @pressEnter="getData" @search="getData" />
      <a-date-picker v-model="query.invoiceTimeFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" allowClear show-today valueFormat="YYYY-MM-DD" />
      <a-date-picker v-model="query.invoiceTimeFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" allowClear show-today valueFormat="YYYY-MM-DD" />
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="getData"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120" />
      <vxe-column field="order.countingType" title="business.label.countingType" width="150">
        <span slot-scope="{ row }">{{ countingTypeData.find(item => item.ordinal === row.order.countingType).name }}</span>
      </vxe-column>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120" />
      <vxe-column field="order.orderStatus" sortable title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{ orderStatusData.find(item => item.ordinal === row.order.orderStatus).name }}</span>
      </vxe-column>
      <vxe-column field="order.operator" title="business.label.operator" width="120" />
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="150" />
      <vxe-column field="item.no" title="business.label.itemNo" width="80" />
      <vxe-column field="item.name" title="business.label.itemName" width="150" />
      <vxe-column field="pack.specification" title="business.label.specification" width="150" />
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo" width="150" />
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="lot.producingArea" title="business.label.producingArea" width="150" />
      <vxe-column field="container.no" sortable title="business.label.containerNo" width="90" />
      <vxe-column field="location.no" sortable title="business.label.locationNo" width="150" />
      <vxe-column field="zone.name" title="business.label.zone" width="150" />
      <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="150" />
      <vxe-column field="detail.inventoryState" sortable title="business.label.inventoryState" width="150">
        <span slot-scope="{ row }">{{ inventoryStateData.find(item => item.ordinal === row.detail.inventoryState).name }}</span>
      </vxe-column>
      <vxe-column field="detail.quantity" sortable title="business.label.quantity" width="120" />
      <vxe-column field="detail.reasons" title="business.label.reason" width="150" />
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'CountingDetailQuery',
    data() {
      return {
        data: [],
        storerData: [],
        orderStatusData: [],
        countingTypeData: [],
        inventoryStateData: [],
        loading: false,
        page: 1,
        size: 20,
        contentSize: 0,
        query: {
          'order.no': '',
          invoiceTimeFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'item.barcodes': '',
          countingType: undefined
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('CountingType').then(res => {
        if (res.success) {
          this.countingTypeData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
      findEnum('InventoryState').then(res => {
        if (res.success) {
          this.inventoryStateData = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.invoiceTimeFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.invoiceTimeFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        let args = Object.assign({}, this.query)
        if (args.invoiceTimeFilter.start === null && args.invoiceTimeFilter.end === null) {
          args.invoiceTimeFilter = null
        }
        findAll('countingDetailFactory', args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            setTimeout(() => {
              this.loading = false
            }, 300)
          } else {
            this.loading = false
          }
        })
      },
      exportExcel() {
        this.$refs.table.openExport()
      },
      reset() {
        this.query = {
          'order.no': '',
          invoiceTimeFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.mnemonicCode': '',
          'item.barcodes': '',
          countingType: undefined
        }
        this.getData()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 180px;
  }
</style>